import { createReducer, on } from "@ngrx/store";
import { initialProvinciasState } from "../../core/interfaces/models/provincia.interface";
import { addProvincias, addProvinciasError, clearProvincias, deleteProvincia, updateProvincia } from "../actions/provincias.actions";

export const provinciaReducer = createReducer(
  initialProvinciasState,
  on(addProvincias, (state, { provinciasState }) => ({
    ...state,
    provincias: [...(state.provincias || []), ...(provinciasState.provincias || [])]
  })),
  on(addProvinciasError, (state, { debugMessage }) => ({
    ...state,
    error: true,
    debugMessage
  })),
  on(updateProvincia, (state, { provincia }) => ({
    ...state,
    provincias: state.provincias.map(u =>
      u.id === provincia.id ? provincia : u
    )
  })),
  on(deleteProvincia, (state, { id }) => ({
    ...state,
    provincias: state.provincias.filter(u => u.id !== id)
  })),

  on(clearProvincias, () => initialProvinciasState)
);
